export enum AlexiRoutes {
  CALLBACK = 'callback',
  LOAN_APPLICATION = 'application',
  LOAN_APPLICATION_AGENT = 'agent-application',
  LOGIN = 'login',
  DASHBOARD = 'dashboard',
  SG_ONBOARDING = 'sg-kyb',
  SG_NETS_ONBOARDING = 'sg-kyb-nets',
  SG_NETS_CO_APPLICANT = 'co-applicant-nets-kyc',
  SG_VENDORS_ONBOARDING = 'sg-vendors-onboarding',
  PARTNER_CONNECT = 'partnerconnect',
  CO_APPLICANT = 'co-applicant',
  SAJ_CO_APPLICANT_KYC = 'co-applicant-kyc',
  CO_APPLICANT_KYB = 'co-applicant-kyb',
}
